'use client';

import { Heading, TextField, TextPassage } from '@petsmart-ui/sparky';
import type { PersonalizedProductSectionProps } from '@app/pdp/components/PersonalizedProduct';
import type { ChangeEvent } from 'react';

export default function PersonalizedProductSection({
    title,
    text,
    inputs,
    onInputChange,
    onBlur,
}: PersonalizedProductSectionProps) {
    return (
        <div className="personalize-drawer-section">
            <Heading
                tagName="h2"
                size="body-lg-bold"
                className="personalize-drawer-section-heading"
            >
                {title}
            </Heading>
            <TextPassage className="personalize-drawer-section-text">
                {text}
            </TextPassage>
            {inputs.map((input, index) => (
                <TextField
                    key={input.label}
                    className="personalize-drawer-field"
                    onInput={(event: ChangeEvent<HTMLInputElement>) =>
                        onInputChange?.(event, index)
                    }
                    onBlur={onBlur}
                    {...input}
                    data-testid="personalize-input"
                />
            ))}
        </div>
    );
}
